import cx from 'classnames'

import Styles from './Properties.module.scss'

import { usePropertiesPermissions } from 'hooks/usePropertiesPermissions'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { FOLDER_PATH, HANDBOOK_PATH } from 'paths'
import { PropertyForm } from 'common/PropertyForm/PropertyForm'
import { ChangeVisibilityButton } from './ChangeVisibilityButton'
import { EditableProperty } from './Properties'
import { Tag } from 'common/OptionSelect/Tag'
import { Button } from 'components/Button/Button'
import { ReactComponent as SettingsIcon } from 'assets/icons/settings16.svg'
import { Property, PropertyValue } from 'api/clients/PropertyClient'

type Props = {
  editableProperty: EditableProperty
  onClose: () => void
}

export const EditWorkflowProperty = ({ editableProperty, onClose }: Props) => {
  const { property } = editableProperty
  const { canEdit } = usePropertiesPermissions(property)
  const history = useHistory()
  const settingsUrl = useRouteMatch([HANDBOOK_PATH, FOLDER_PATH])?.url

  const goToWorkflowSettings = () => {
    history.push(`${settingsUrl}/settings/statuses`)
    onClose()
  }

  const infoText = canEdit
    ? 'This status property and automations can be configured in folder settings.'
    : 'This property is created in a folder that you do not have edit access to.'

  return (
    <>
      <PropertyForm
        variant="large"
        property={{ ...property, default_type: 'status' } as Property} // hack: don't show type selector
        type={property.type}
        propertyTypes={[]}
        disabled={true}
        forceShowNameInput={true}
      />
      <div className={Styles.mdText}>{infoText}</div>
      <div className={Styles.propertyValuesContainer}>
        {property.property_values.map((value: PropertyValue) => (
          <Tag key={value.id} color={value.meta?.color ?? ''}>
            {value.value}
          </Tag>
        ))}
      </div>
      <div className={Styles.divider}></div>
      {canEdit && (
        <div className={Styles.flexContainer}>
          <Button
            className={cx(Styles.flexContainer, Styles.flexGrow, Styles.horizontalPadding, Styles.columnGap0)}
            variant="tertiary"
            size="lg"
            onPress={goToWorkflowSettings}
          >
            <SettingsIcon className={Styles.icon} />
            <div>Edit Statuses</div>
          </Button>
        </div>
      )}
      <ChangeVisibilityButton editableProperty={editableProperty} onClose={onClose} />
    </>
  )
}
